export default "__VITE_ASSET__DT7aMJaI__"